import { render, staticRenderFns } from "./RestartDeliveriesAction.vue?vue&type=template&id=3801e32a&"
import script from "./RestartDeliveriesAction.vue?vue&type=script&lang=js&"
export * from "./RestartDeliveriesAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports